module.exports = __webpack_public_path__ + "img/screenshot1.d723ff03.svg";